export default "__VITE_ASSET__C7MUn1Cn__"